/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";

// TODO: consider moving to utility module
ko.bindingHandlers.glass = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var glass = document.createElement("div");
		glass.style.position = "absolute";
		glass.style.top = 0;
		glass.style.left = 0;
		glass.style.bottom = 0;
		glass.style.right = 0;
		glass.style.background = "transparent";
		bindingContext.glass = glass;

		ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
            // This will be called when the element is removed by Knockout or
            // if some other part of your code calls ko.removeNode(element)
            if(glass.parentElement) {
            	document.body.removeChild(glass);
            }
        });
	},
	update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var val = ko.unwrap(valueAccessor());
		var glass = bindingContext.glass;
		if(val) {
			document.body.appendChild(glass);
		} else if(glass.parentElement) {
			document.body.removeChild(glass);
		}
	}
};

ko.bindingHandlers.glassClick = {
	init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		if(bindingContext.glass) {
			bindingContext.glass.addEventListener("click", function(evt) {
				// alert(evt);
				ko.unwrap(valueAccessor())(evt);
			})
		}
	},
	update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
		// NOOP
	}
};

ko.components.register('popup-menu', {
	viewModel: function(params) {
		params = params || {};
		var self = this;

		self.show = params.show;
		self.selectedOption = params.selectedOption;
		self.options = params.options;

		self.selectOption = function(data, evt) {
			self.selectedOption(data);
			self.show(false);
			evt.stopPropagation(); // otherwise menu will be immediately shown again
		};
	},
	template: require('../../../templates/shared/popup-menu.html')
});
